import { useMemo } from 'react';
import cn from 'classnames';
import Sector from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Sector';
import TickerCell from '@/creditflowresearch/ui/common/components/TableCells/TickerCell';
import Status from '@/creditflowresearch/ui/common/components/TableCells/DealStatus';
import DealName from '@/creditflowresearch/ui/components/deals/DealListTable/cells/DealName';
import ParentCompany from '@/creditflowresearch/ui/components/deals/DealListTable/cells/ParentCompany';
import Region from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Region';
import DealDateCell from '@/creditflowresearch/ui/common/components/TableCells/DealDateCell';
import ProductAbbreviation from '@/creditflowresearch/ui/components/deals/DealListTable/cells/ProductAbbrevation';
import ABSLeads from '@/creditflowresearch/ui/components/deals/DealListTable/cells/ABSLeads';
import Tools from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Tools';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import styles from '../table.module.scss';

export const useTableColumns = () => {
  const columns = [
    {
      name: 'product',
      title: 'C/P',
      width: 55,
      minWidth: 55,
      className: alignStyles.alignCenter,
      cellCallback: ProductAbbreviation,
    },
    {
      name: 'sector',
      title: 'Sector',
      width: 70,
      minWidth: 70,
      className: alignStyles.alignCenter,
      cellCallback: Sector,
    },
    {
      name: 'status',
      title: 'Status',
      width: 70,
      minWidth: 70,
      className: alignStyles.alignCenter,
      cellCallback: ({ row }) => <Status status={ row.status } />,
    },
    {
      name: 'ticker',
      title: 'Ticker',
      width: 70,
      minWidth: 70,
      className: cn(alignStyles.alignCenter, styles.tickerLabel),
      cellCallback: (cellProps) => <TickerCell cell={ cellProps } isDeal isBadge />,
    },
    {
      name: 'primaryIssuer',
      title: 'Deal Name',
      width: 510,
      minWidth: 510,
      className: alignStyles.alignLeft,
      cellCallback: DealName,
    },
    {
      name: 'parent',
      title: 'Parent',
      width: 290,
      minWidth: 290,
      className: cn(alignStyles.alignLeft, styles.parentCell),
      cellCallback: ParentCompany,
    },
    {
      name: 'leads',
      title: 'Leads',
      className: alignStyles.alignRight,
      minWidth: 150,
      cellCallback: ABSLeads,
    },
    {
      name: 'region',
      title: 'Region',
      className: alignStyles.alignRight,
      width: 80,
      minWidth: 80,
      cellCallback: ({ row }) => <Region region={ row.region } country={ row.country } />,
    },
    {
      name: 'expand',
      title: 'Date',
      className: alignStyles.alignRight,
      width: 110,
      minWidth: 110,
      cellCallback: DealDateCell,
    },
    {
      name: 'tools',
      title: '',
      className: alignStyles.alignCenter,
      width: 100,
      minWidth: 100,
      cellCallback: Tools,
    },
  ];

  return useMemo(
    () => columns,
    [],
  );
};
